import { Box, styled, Typography } from "@mui/material";

const Wrapper = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const ImageTile = styled(Box)`
    box-sizing: border-box;
    width: 15.27%;
    height: auto;
    min-width: 274.3px;
    min-height: 274.3px;
    display: block;
    border-radius: 5px;

    @media (max-width: 480px) {
      gap: 0;
    }
`;

export const MediaTile = (props) => 

<Wrapper>
    <ImageTile sx= {{ backgroundImage: props.image }}/>
    <Typography  sx={{ marginTop: "15px" }} variant="body2" color="white">
        {props.text}
    </Typography>
</Wrapper>;
